/* src/app/addons/task/task-list.component.css */
th {
  text-align: left;
}
.task-description {
  font-weight: normal;
}
/*# sourceMappingURL=task-list.component-ZDPVWPLK.css.map */
